import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface MenuItem {
  path: string;
  icon: string;
  label: string;
}

interface DropdownMenuProps {
  label: string;
  icon: string;
  items: MenuItem[];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ label, icon, items }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLLIElement>(null);
  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  return (
    <li className={`dropdown ${isOpen ? 'active' : ''}`} ref={dropdownRef}>
      <div className="dropdown-toggle" onClick={toggleDropdown}>
        <span className="nav-icon">{icon}</span> {label}
      </div>
      <ul className="dropdown-menu">
        {items.map((item, index) => (
          <li key={index}>
            <Link to={item.path} onClick={() => setIsOpen(false)}>
              <span className="nav-icon">{item.icon}</span> {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default DropdownMenu;
